import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BuyRoutingModule } from './buy.routing';

import { AlertsComponent } from './components/alerts/alerts.component';

import { MatCardModule } from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';

import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatListModule } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';

import { MatTooltipModule } from '@angular/material/tooltip';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { BuySearchComponent } from './components/buy-search/buy-search.component';
import { BuyComponent } from './buy.component';
import { BuyHomeComponent } from './components/buy-home/buy-home.component';
import { BuyCarDetailsComponent } from './components/buy-car-details/buy-car-details.component';

import { BuyCarCardListComponent } from './components/buy-car-card-list/buy-car-card-list.component';
import { BuyCarBoxListComponent } from './components/buy-car-box-list/buy-car-box-list.component';
import { CarSearchComponent } from '../car/elements/car-cards/car-search.component';
import { CarDetailsComponent } from '../car/elements/car-details/car-details.component';
import { CarCardListComponent } from '../car/elements/car-card-list/car-card-list.component';
import { CarBoxListComponent } from '../car/elements/car-box-list/car-box-list.component';


@NgModule({
  declarations: [
    BuyComponent,
    AlertsComponent, 
    BuySearchComponent, 
    BuyHomeComponent, 
    BuyCarDetailsComponent, 
    BuyCarCardListComponent, 
    BuyCarBoxListComponent
    
  ],
  imports: [
    CommonModule,

    FormsModule,
    ReactiveFormsModule,
    
    BuyRoutingModule,
    MatCardModule,
    MatGridListModule,
    MatIconModule,
    MatSelectModule,
    MatListModule,
    MatButtonModule,
    
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    
    MatTooltipModule,
    OverlayModule,

    CarSearchComponent,
    CarDetailsComponent,
    CarCardListComponent,
    CarBoxListComponent
  ]
})
export class BuyModule { }
